import { GlCollapsibleListbox, GlFormCheckbox, GlTooltip } from '../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
import { PARALLEL_DIFF_VIEW_TYPE, INLINE_DIFF_VIEW_TYPE } from '../constants';
import { SETTINGS_DROPDOWN } from '../i18n';
export default {
    name: 'SettingsDropdown',
    i18n: SETTINGS_DROPDOWN,
    toggleId: 'js-show-diff-settings',
    components: {
        GlCollapsibleListbox,
        GlFormCheckbox,
        GlTooltip
    },
    props: {
        showWhitespace: {
            type: Boolean,
            required: true
        },
        diffViewType: {
            type: String,
            required: true
        },
        viewDiffsFileByFile: {
            type: Boolean,
            required: false,
            default: false
        },
        fileByFileSupported: {
            type: Boolean,
            required: false,
            default: true
        }
    },
    emits: [
        'toggle-file-by-file',
        'toggle-whitespace',
        'update-diff-view-type'
    ],
    methods: {
        tooltipTarget () {
            return document.querySelector(`.${this.$options.toggleId}`);
        }
    },
    diffViewTypeOptions: [
        {
            text: __('Side-by-side'),
            value: PARALLEL_DIFF_VIEW_TYPE
        },
        {
            text: __('Inline'),
            value: INLINE_DIFF_VIEW_TYPE
        }
    ]
};
